import Vue from 'vue/dist/vue.esm';
import App from './App.vue'
import VueHead from 'vue-head'
import router from './router/index.js'


Vue.use(VueHead)


Vue.config.productionTip = false

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

export default new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App/>',
  head:{
    script: [
   
    ],
  },
 
  

})
